import React from 'react';
import { countdownLabel } from '../../derivations/schedule';

// Schedule readout in v2's calm vocabulary. Pure display — no "Open session
// room" / "Set reminder" buttons (deferred until session-room infrastructure
// lands post-Cloudflare restructuring; players just open their character
// from the campaign page to join in for now).
export const CalmNextSession = ({ schedule, palette, bodyFont, headingFont, c }) => {
  const countdown = countdownLabel(schedule);
  const isTonight = countdown === 'Tonight';

  return (
    <div>
      <div style={{ marginBottom: 14 }}>
        <div style={{
          fontFamily: headingFont,
          fontSize: '1.4rem',
          fontWeight: 600,
          color: schedule ? palette.light : c.textMuted,
          lineHeight: 1.1,
          marginBottom: 3,
          textShadow: isTonight ? `0 0 18px ${palette.glow}` : 'none',
          fontStyle: schedule ? 'normal' : 'italic',
        }}>{schedule ? (countdown || schedule) : 'No session scheduled'}</div>
        {schedule && (
          <div style={{
            fontFamily: bodyFont,
            fontSize: '0.78rem',
            color: c.textMuted,
          }}>{schedule}</div>
        )}
      </div>
    </div>
  );
};
